export enum helpUrl {
    DEFAULT = 'index.html',
    SUPPORT = 'support_index.html',
    SCAN = 'Scan_index.html',
}
